import { Get } from '../http/httpVerbs';

export const apiGetLogs = async ({ idUsuario, idCreators = [] }) => {
    try {
        if (idCreators.length > 100) {
            const chunkSize = 100;
            const chunks = [];
            for (let i = 0; i < idCreators.length; i += chunkSize) {
                chunks.push(idCreators.slice(i, i + chunkSize));
            }
            
            const allLogs = [];
            for (const chunk of chunks) {
                const params = new URLSearchParams();
                if (idUsuario) params.append("idUsuario", idUsuario);
                params.append("idCreators", JSON.stringify(chunk));
                
                const response = await Get(`${process.env.REACT_APP_API_URL}/logs?${params.toString()}`);
                if (Array.isArray(response)) {
                    allLogs.push(...response);
                }
            }
            return allLogs;
        }
        
        const params = new URLSearchParams();
        
        if (idUsuario) params.append("idUsuario", idUsuario);
        if (idCreators.length > 0) params.append("idCreators", JSON.stringify(idCreators));

        const response = await Get(`${process.env.REACT_APP_API_URL}/logs?${params.toString()}`);
        return response;
    } catch (error) {
        throw error;
    }
};
